export var stripRedundantData = function stripRedundantData(rawNavData) {
  return {
    navigation_categories: rawNavData.navigation_categories.map(function (navCategory) {
      delete navCategory.category._metadata;
      navCategory.category.columns = navCategory.category.columns.map(function (column) {
        delete column._metadata;
        column.column_sections = column.column_sections.map(function (columnSection) {
          delete columnSection._metadata;
          columnSection.links = columnSection.links.map(function (link) {
            delete link._metadata;
            return link;
          });
          return columnSection;
        });
        return column;
      });
      return navCategory;
    })
  };
};